/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */

import vasActivationModalTemplate from './SavedWithSuccessModal.html';


class TaxationSettingsController {
  /* @ngInject */



  constructor($log, $q, $timeout, MerchantConfigurationService,
              MerchantVasService, $scope, $rootScope,
              ModalFactory, TermsService, StorageService, NewTokenService) {

    const that = this;
    that.currentVasTypeId = MerchantVasService.getVasesTypes()['INVOICES'];
    that.currentWalletId = NewTokenService.getMerchantWalletID();
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');

    that.vat = [4,10,22];
    this.showVasConfigurationSuccess = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: vasActivationModalTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    that.save = () => {
      MerchantVasService
        .configureVas(that.currentVas.configuration, that.currentVas.id)
        .then(
          (ok) => {
            that.currentVas.configuration = ok.data;
            that.showVasConfigurationSuccess();
          }
        );
    };

    const init = () => {

      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
          },
          (error) => {
            alert('error retrieving the vas!');
          }
        );

    };


    that.$onInit = init;

  }

}

export default TaxationSettingsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/settings/settings.controller.js
 **/